import React, {Component, Fragment} from 'react';

import { AiOutlineFileImage, AiOutlineVideoCameraAdd, AiOutlineAppstoreAdd, AiFillDelete } from "react-icons/ai";
import { FaSpinner } from "react-icons/fa";



import * as Constant from '@app/Constant.js';

import axios from '@app/lib/axios';

import Account from './account.js';
import Childs from './childs.js';
import Devices from './devices.js';


class Detail extends Component {

	constructor(props) {
		super(props);

		this.state= {
			doSubmit : false,
			isLoaded : false,
			msg : "",
			id : this.props.id || 0,
			account : {},
			childs : [],
			devices : []
		};
	}

	componentDidMount(){    
        this.getData(this.state.id);
    }

    getData = (id) => {
		this.setState(
			{isLoaded : false, msg : "데이터 로딩 중입니다."}, 
			() => {
				axios({
			          method: "get",
			          url: Constant.API_DOMAIN+`/api/flyeng/parent/info/${id}`
			        })
				    .then(result => {
				        if(result.data.code === 200) {  
				        	console.log(result.data);
			        		this.setState({
			        			isLoaded : true,
								account : result.data.account,
								childs : result.data.childs,
								devices : result.data.devices
							});
				        } else {
							alert(result.data.msg);
							this.cancelForm();

				        }
				        
				      })
				      .catch(error => {
				        console.log(error);
				        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
				        this.cancelForm();
				    });
				    
			}

		);
    }


	cancelForm = () => {
		document.location.href = `./parent?page=${Number(this.props.page)}&service=flyeng&type=${this.props.type}&keyword=${this.props.keyword}&status=${this.props.status}`;
	}

	render() {
		if(this.state.isLoaded) {
			return (
				
					<Fragment>
						<div className="row">
	                    	<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                <div className="page-header">
                                    <h3>플라잉 계정 상세정보</h3>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                <div className="float-right">
                                    <button className="btn btn-primary" onClick={this.cancelForm}>
                                    	확인
                                    </button>
                                </div>
                            </div>
                        </div>

						<div className="row">
							<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
								<Account account={this.state.account} />
							</div>
						</div>
						<div className="row">
							<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
								<Childs childs={this.state.childs} />
							</div>
							<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
								<Devices devices={this.state.devices} id={this.state.account.id}/>
							</div>
						</div>
						<div className="row">
							<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
								<div className="float-right">
									<button className="btn btn-primary" onClick={this.cancelForm}>확인</button>
								</div>
							</div>
						</div>
					</Fragment>
				
			)
		} else {
			return (
                <div className="card border-top">
                    <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", padding:"50px"}}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                        <div style={{marginTop : "15px"}}>
                        	<p>{this.state.msg}</p>
                        	<p>{this.state.uploading}</p>
                        </div>
                    </div>
                </div>
            )
		}
		
	}
};

export default Detail ;